import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface UnsplashAttributionProps {
  photographerName: string;
  photographerUsername: string;
  variant?: "body2" | "caption" | "body1";
  className?: string;
}

const UTM_SOURCE = "zeffy";
const UTM_MEDIUM = "referral";

export const UnsplashAttribution = ({
  photographerName,
  photographerUsername,
  variant = "body2",
  className,
}: UnsplashAttributionProps) => {
  const photographerUrl = `https://unsplash.com/@${photographerUsername}?utm_source=${UTM_SOURCE}&utm_medium=${UTM_MEDIUM}`;

  return (
    <DashboardTypography variant={variant} className={className}>
      <a
        href={photographerUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "underline" }}
      >
        {photographerName}
      </a>
    </DashboardTypography>
  );
};
